import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			siteMapHeroContentSectionHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Site Map Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.siteMapHeroContentSectionHeaderCls || '', 'site_map_hero', { animCls: 'animate__fadeInDown', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;